// extracted by mini-css-extract-plugin
module.exports = {"okButtonConfirm":"styles_okButtonConfirm__3iffe","cancelButtonConfirm":"styles_cancelButtonConfirm__1wxpr"};